import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Stack, Text } from "@mantine/core";

const PaymentMethodAccepted: React.FC = () => {
  const { t } = useAppTranslation("pages.order.basket.acceptedPayments");
  return (
    <Stack className="basket-container !px-9" align="start">
      <Group wrap="nowrap">
        <AppThemeIcon className="size-10">
          <Icon.ShieldWhite className="pt-2" />
        </AppThemeIcon>
        <Stack gap={0}>
          <SSWhiteText className="font-extrabold font-secret-narrow">
            {t("safePayments")}
          </SSWhiteText>
          <Text className="font-inter text-primary-dark-text text-xs">
            {t("description")}
          </Text>
        </Stack>
      </Group>
      <Group className="pt-2 md:ml-14">
        <AppThemeIcon className="size-7">
          <Icon.PaymentVisaCard />
        </AppThemeIcon>
        <AppThemeIcon className="size-7">
          <Icon.PaymentMasterCard />
        </AppThemeIcon>
        <AppThemeIcon className="size-7">
          <Icon.PaymentAmericanCard />
        </AppThemeIcon>
        <AppThemeIcon className="size-7">
          <Icon.PaymentPaypalCard />
        </AppThemeIcon>
        <AppThemeIcon className="size-7">
          <Icon.PaymentApplePayCard />
        </AppThemeIcon>
        <AppThemeIcon className="size-7">
          <Icon.PaymentKarnaCard />
        </AppThemeIcon>
      </Group>
    </Stack>
  );
};

export default PaymentMethodAccepted;
